import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      // stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.2 6.582a91.532 91.532 0 0 0-9.018-.45c-1.782 0-3.564.09-5.346.27L4 6.582m4.95-.909.198-1.179C9.292 3.639 9.4 3 10.92 3h2.358c1.52 0 1.638.675 1.773 1.503l.198 1.17m3.016 3.753-.585 9.063C17.581 19.902 17.5 21 14.99 21H9.21c-2.51 0-2.592-1.098-2.69-2.511l-.586-9.063m4.663 6.624h2.997m-3.744-3.6h4.5"
    />
  </svg>
);
export default SvgDelete;
